import { inject, Injectable } from '@angular/core';
import { filter, Observable, ReplaySubject } from 'rxjs';
import { MicrosoftSharedVoicemailGroupsFieldConfig } from '../models/generated/ziroModels';
import { HttpClient } from '@angular/common/http';
import { switchMap, take, tap } from 'rxjs/operators';
import { MicrosoftTenantsStateContext } from './microsoft-tenants-state.context';

@Injectable()
export class MicrosoftSharedVoicemailGroupsMembershipContext {
  private http = inject(HttpClient);
  private _tenantsStateContext = inject(MicrosoftTenantsStateContext);

  private _stateSource = new ReplaySubject<MicrosoftSharedVoicemailGroupsFieldConfig>(1);
  state$ = this._stateSource.asObservable();
  private _tenantId: string;

  constructor() {
    this.refresh().subscribe();
  }

  refresh(): Observable<MicrosoftSharedVoicemailGroupsFieldConfig> {
    return this._tenantsStateContext.cachedTenantState$.pipe(
      filter((cachedTenant) => !!cachedTenant?.tenantId),
      take(1),
      tap((cachedTenant) => {
        this._tenantId = cachedTenant.tenantId.toString();
      }),
      switchMap(() =>
        this._getSharedVoicemailGroupsFieldConfig().pipe(
          tap((fieldConfig: MicrosoftSharedVoicemailGroupsFieldConfig) => {
            this._stateSource.next(fieldConfig);
          }),
        ),
      ),
    );
  }

  private _getSharedVoicemailGroupsFieldConfig(): Observable<MicrosoftSharedVoicemailGroupsFieldConfig> {
    return this.http.get<MicrosoftSharedVoicemailGroupsFieldConfig>(
      `/services/microsoft/teams-user-management/tenants/${this._tenantId}/field-configs/shared-voicemail-permissions`,
    );
  }
}
